import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import DocumentMeta from 'react-document-meta';
import Social from '../blocks/Social';
import { ROOT_DIR, LOCATION, DOMAIN } from '../../utils/Constants';
import HomepageEvents from '../blocks/HomepageEventsEventbriteAPI';
import HomepageFeatures from '../blocks/HomepageFeatures';
import HomepagePhotos from '../blocks/HomepagePhotos';
import HomepagePopular from '../blocks/HomepagePopular';
import PageLoader from '../pieces/PageLoader';
import GoogleAd from '../pieces/GoogleAd';

const style = {
  display: 'block'
}

class Home extends Component {
  state = {
    loaded: false
  }
  componentDidMount(){
    window.scrollTo(500, 0);
  }
  onImageLoad = () => {
    this.setState({ loaded: true })
  }
  render(){
    const meta = {
      title: `― ${LOCATION} Online ― find businesses, services, events and more on ${LOCATION}, Essex, UK in our business directory`,
      description: `Find businesses, services, events and more in ${LOCATION}, Essex, UK. Business directory for ${LOCATION}, Essex`,
      canonical: `http://www.${DOMAIN}`,
      meta: {
        keywords: `${LOCATION}, Essex, online, ${LOCATION} businesses, ${LOCATION} business directory, ${LOCATION} services, ${LOCATION} events, UK, United Kingdom`
      }
      
    };
    return(
      <div>
        <DocumentMeta {...meta} />
        {!this.state.loaded && 
          <PageLoader/>
        }
        <div>
          <div className="banner home-banner">
  
          <Social/>
          
          <picture>
              <source media="(min-width: 769px)" srcSet="assets/img/home-banner.jpg"/>
              <source media="(max-width: 768px)" srcSet="assets/img/home-banner-mob.jpg"/>
              <img src="assets/img/home-banner.jpg" alt={LOCATION} onLoad={this.onImageLoad}/> 
            </picture>
            <div className="info-box">
              <h2 className="info-box-headline no-margin">Get in there!</h2>
              <p><span className="standout-light bold">{LOCATION} Online</span> is the place to go to find out about businesses, services, events and more in {LOCATION}, Essex. By signing up now, you can get your business, service or event listed in a prime position for free!</p>
              <Link to="/getfound" className="button cta">Get my free prime listing</Link>
            
          </div>
          
            
        </div>

        <div className="page-content-wrapper">
          <section className="events-wrapper">
            <HomepageEvents
              events={this.props.events}
            />
          </section>

          <section className="feature-wrapper">
            <HomepageFeatures/>
          </section>

          <div className="row">
            <div className="large-12 columns">
              <GoogleAd 
                client="ca-pub-3501112787403549" 
                slot="9802299641" 
                format="auto" 
                wrapperDivStyle={style}
              /><br/>
            </div>
          </div>

          <section className="feature-wrapper feature-popular">
            <HomepagePopular/>
          </section>

        </div>
        </div>
        
        
      </div>
    );
  }
}
export default Home;


// WEBPACK FOOTER //
// ./src/components/pages/Home.js